import {Component, model, ModelSignal} from '@angular/core';
import AppControlGuids from '../../../../api/ControlGuids';
import {
  CSV_IMPORT_ACTION,
  DEFAULT_TABLE_ACTIONS,
  ITableAction,
  TableControlComponent,
  TableControlModule,
} from 'frontier';

@Component({
  selector: 'app-dictionary-import-table',
  standalone: true,
  imports: [TableControlModule],
  templateUrl: '../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrl: '../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss',
})
export class DictionaryImportTableComponent extends TableControlComponent {
  override GUID: string = AppControlGuids.TDictionaryImportView;
  override actions: ModelSignal<ITableAction[]> = model<ITableAction[]>([
    ...DEFAULT_TABLE_ACTIONS,
    CSV_IMPORT_ACTION,
  ]);
}
